import { Grid, TextInput, Checkbox } from "@mantine/core";
import { useSetState } from "@mantine/hooks";
import { useEffect } from "react";

export default function TextField(props) {
  const [values, setValues] = useSetState({
    ...props.field,
  });

  useEffect(() => {
    props.setFieldValues(props.field.id, values);
  }, [values]);

  return (
    <Grid gpas={"xl"}>
      <Grid.Col span={12}>
        <Checkbox
          label="Required"
          defaultValue={props.field.required}
          checked={values.required}
          onChange={(e) => setValues({ required: e.currentTarget.checked })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Field Label"
          variant="filled"
          defaultValue={values.label}
          onChange={(e) => setValues({ label: e.currentTarget.value })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Field Translation"
          variant="filled"
          defaultValue={values.translation}
          onChange={(e) => setValues({ translation: e.currentTarget.value })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput placeholder="Default Value" variant="filled" />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Placeholder (Default value is field label)"
          defaultValue={values.placeholder}
          variant="filled"
          onChange={(e) => setValues({ placeholder: e.currentTarget.value })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Regex Pattern"
          variant="filled"
          onChange={(e) => setValues({ regex: e.currentTarget.value })}
        />
      </Grid.Col>
    </Grid>
  );
}
